import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import {
  Grid,
  Container,
  Modal,
  Button,
  Dimmer,
  Loader,
  Segment,
} from "semantic-ui-react";
import moment from "moment";
import { fetchAllRooms, updateShowCreateRoom } from "../reducers/room";
import MainMenu from "./../components/MainMenu";
import { connect } from "react-redux";
import CheckinQueue from "./../components/CheckinQueue";
import CreateRoom from "./../components/CreateRoom";
import { withTranslation } from "react-i18next";

const localizer = momentLocalizer(moment);

class ExamSchedule extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      learners: [],
      exam: "",
      showCreateRoom: false,
      showAllHours: false,
    };
  }
  componentDidMount() {
    this.props.fetchAllRooms();
  }

  render() {
    return (
      <Container>
        <MainMenu />
        <Modal
          open={this.state.open}
          closeIcon
          onClose={() => {
            this.setState({ open: false });
          }}
        >
          <Modal.Content>
            <CheckinQueue
              close={() => this.setState({ open: false })}
              room={this.state.room}
              ws={this.props.socket}
            />
          </Modal.Content>
        </Modal>

        <CreateRoom
          close={() => this.setState({ showCreateRoom: false })}
          open={this.state.showCreateRoom}
        />
        <Grid>
          <Grid.Column>
            <Button
              basic
              icon={this.state.showAllHours ? "compress" : "expand"}
              content={
                this.state.showAllHours
                  ? "Hide Early Hours (7 AM - 12 AM)"
                  : "Expand All Hours (12 AM - 12 AM)"
              }
              onClick={() =>
                this.setState({ showAllHours: !this.state.showAllHours })
              }
            />
            <Button
              color="green"
              floated="right"
              onClick={() => this.props.updateShowCreateRoom(true)}
            >
              {this.props.t("ExamSchedule.createRoom")}
            </Button>
          </Grid.Column>
        </Grid>

        <Grid centered columns={2}>
          &nbsp;
        </Grid>
        <Dimmer.Dimmable
          as={Segment}
          dimmed={this.props.rooms.showLoader}
          style={{ border: "none", boxShadow: "none" }}
        >
          <Grid centered columns={2}>
            <Dimmer active={this.props.rooms.showLoader} inverted>
              <Loader>{this.props.t("general.loading")}</Loader>
            </Dimmer>
            {
              <Calendar
                dayLayoutAlgorithm="no-overlap"
                localizer={localizer}
                events={this.props.rooms.events}
                style={{ height: "80vh", width: "80vw" }}
                views={["month", "day", "week"]}
                defaultView="day"
                min={
                  this.state.showAllHours
                    ? new Date(0, 0, 0, 0, 0, 0)
                    : new Date(0, 0, 0, 7, 0, 0)
                }
                max={new Date(0, 0, 0, 23, 59, 0)}
                step={60}
                showMultiDayTimes
                components={{
                  event: ({ event }) => (
                    <div style={{ padding: "2px 4px", fontSize: "0.9em" }}>
                      <strong>{event.title}</strong>
                    </div>
                  ),
                }}
                onSelectEvent={(event) => {
                  this.setState({
                    open: true,
                    room: event.room,
                  });
                }}
                defaultDate={new Date()}
              />
            }
          </Grid>
        </Dimmer.Dimmable>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginTop: 15,
            marginBottom: 20,
          }}
        >
        </div>
      </Container>
    );
  }
}

export default withTranslation()(
  connect(
    (state) => ({
      rooms: state.rooms,
    }),
    { fetchAllRooms, updateShowCreateRoom }
  )(ExamSchedule)
);
